<template>
  <div v-if="!isLogined" style="padding-top:300px;">
      <p>您还没有登录哦，请先登录</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
  </div>
  <div v-else>
     <van-nav-bar title="兑换收货地址编辑" left-text="" left-arrow @click-left="onClickLeft()" />
     <div style="font-size:15px;color:red;margin-left:15px;margin-top:5px;">*温馨提示：请谨慎填写收货地址，填写后无法更改！</div>
     <van-address-edit
      :area-list="areaList"
      :address-info="AddressInfo"
      show-search-result
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="SaveAddress"
    />
     
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, NavBar, AddressEdit } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from 'vant';
import area from '../utils/area'
export default {
  name: "ConvertAddrsEdit",
  data() {
    return {
      areaList:area,
      ReciveAddr: {},     
      AddressInfo:{}
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    /*返回 */
    onClickLeft() {
      this.$toast("请先保存收货地址！");
    },
    SaveAddress(data){//保存收货地址  
      this.AddressInfo = data;
      this.ReciveAddr={
        id: this.addrId,
        userName: data.name,
        telNumber: data.tel,
        provinceName: data.province,
        cityName: data.city,
        countyName: data.county,
        detailInfo: data.addressDetail,
        areaCode: data.areaCode,
      };
      var that=this;
      that.$http.post("Prizes/CreateConvertAddr",that.ReciveAddr).then(res=>{
        if(res.data=="success"){
          that.$toast("操作成功");
          that.$router.back(-1);
        }else{
          that.$toast(res.data);
        }
      });
    },
  },
  created() {
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]:CountDown,
    [NavBar.name]: NavBar,
    [AddressEdit.name]: AddressEdit,
  },
};
</script>

<style scoped>
    .van-panel {
    margin-top: 20px;
  }
</style>
